'use memo';

import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { TaskModalPageProps } from 'pages/allTasks/TaskModal/TaskModalPageProps';
import TaskModalStepToggle from '../TaskModalStepToggle';
import { resolveQldAgreementComplianceTaskLayout } from '../agreementComplianceTaskLayout';

const QldAgreementDetails = ({
  tasks,
  taskNumber,
  toggleTaskStep,
  toggleTaskStepForTask,
}: TaskModalPageProps) => {
  const { agreementDetailsSteps } = resolveQldAgreementComplianceTaskLayout(tasks);

  return (
    <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
      <AgxTypography size="large" type="label" id="step1title" color="var(--text-primary)">
        {`Step ${taskNumber} : Agreement Compliance`}
      </AgxTypography>
      <AgxSpacer direction="vertical" gap="spacing-xl" fill>
        {agreementDetailsSteps.map(({ task, step }) => (
          <TaskModalStepToggle
            key={`${task.id}-${step.order}`}
            step={step}
            toggleTaskStep={toggleTaskStep}
            large
            onChange={(isChecked) => toggleTaskStepForTask(task.id, step.order ?? 0, isChecked)}
          />
        ))}
      </AgxSpacer>
    </AgxSpacer>
  );
};

export default QldAgreementDetails;
